<template>
  <div>
    <v-row>
      <v-btn
        :color="isCar(item.Codigo) === 0 ? 'accent' : 'primary'"
        fab
        dark
        small
        :absolute="$route.name !== 'Producto'"
        bottom
        right
        style="z-index:1"
        :class="[
          {
            'mt-4 ml-3': $route.name === 'Producto',
          },
          {
            'mb-6 mr-n2': $route.name !== 'Producto',
          },
        ]"
        elevation="0"
        @click="dialog2 = true"
        v-if="!Cliente.showOpc && dataUser.IndAutenticado"
        ><v-icon
          :color="isCar(item.Codigo) === 0 ? 'success-100' : 'success-400'"
        >
          {{
            `mdi-${isCar(item.Codigo) === 0 ? `cart-plus` : `cart-check`}`
          }}</v-icon
        >
      </v-btn>

      <v-dialog v-model="dialog2" persistent max-width="350" scrollable>
        <v-card class="elevation-12" color="warning" dark>
          <v-toolbar dark flat width="380" color="white">
            <v-toolbar-title>
              <v-img
                contain
                :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
                id="Home"
                width="154"
              ></v-img>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="closeDialog" light :disabled="loading">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title class="pa-1 mx-2">{{ item.Codigo }}</v-card-title>
          <v-card-text class="pa-2 mb-2">
            <v-select
              v-if="validaContenido"
              :items="itemsPaletas"
              v-model="selected"
              label="Cantidad de Paletas"
              :menu-props="{ top: false, offsetY: true }"
              :item-text="(item) => `${item.cantp} Paleta (${item.contp} M2) `"
              item-value="cantp"
              dense
              chips
              outlined
              hide-details
              return-object
              single-line
              :disabled="loading"
            >
              <template v-slot:selection="{ attrs, item, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  color="secondary"
                  class="primary--text"
                  close
                  @click:close="remove()"
                >
                  <v-icon left color="success"> mdi-check </v-icon>
                  <strong>{{ item.cantp }} Paleta </strong>&nbsp;
                  <span>({{ item.contp }} M2)</span>
                </v-chip>
              </template> </v-select
            ><v-text-field
              v-else
              label="Unidades"
              @keypress="isNumber($event)"
              dense
              filled
              hide-details
              return-object
              type="number"
              v-model.number="selected"
              min="1"
            ></v-text-field>
          </v-card-text>
          <v-divider color="#D3BC8D"></v-divider>
          <v-card-actions>
            <v-spacer />
            <v-btn
              elevation="0"
              color="primary"
              :loading="loading"
              @click="
                addCar({
                  articulo: item.Codigo,
                  promo: 0,
                  cantidad: validaContenido ? selected.contp : selected,
                })
              "
              :disabled="selected === 0 || loading || selected === ''"
            >
              agregar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    item: Object | Array,
  },

  data() {
    return {
      dialog2: false,
      selected: this.$route.name === "Producto" ? 1 : 0,
      loading: false,
    };
  },

  methods: {
    ...mapActions(["set_cargaArtCarrito"]),
    ...mapMutations(["set_mensaje"]),
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 9) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    remove() {
      this.selected = this.$route.name === "Producto" ? 1 : 0;
    },

    async addCar({ articulo, promo, cantidad }) {
      this.loading = true;

      await this.set_cargaArtCarrito({
        articulo,
        cantidad,
        promo,
      });

      this.loading = false;
      this.selected = this.$route.name === "Producto" ? 1 : 0;
      this.dialog2 = false;
    },
    closeDialog() {
      this.selected = this.$route.name === "Producto" ? 1 : 0;
      this.dialog2 = false;
    },
  },
  computed: {
    ...mapState(["domoapi2_img", "Cliente", "dataUser", "Pedido"]),
    isCar: function () {
      return function (cod) {
        return this.Pedido.items
          .filter((x) => x["Codigo"] === cod)
          .map((x) => x["Codigo"]).length;
      };
      //
    },
    validaContenido() {
      const { ContentDetal } = this.item;
      return ContentDetal !== 1;
    },
    itemsPaletas() {
      const idDisponible =
        this.$route.name === "Producto" ? `DisponNum` : `Disponible`;
      const { ContentMayor, [idDisponible]: Disponible } = this.item;
      const longitudArray = Math.floor(Disponible / ContentMayor);
      const array = Array.from({ length: longitudArray }, (_, i) => ({
        cantp: i + 1,
        contp: parseFloat((ContentMayor * (i + 1)).toFixed(2)),
      }));
      return array;
    },
  },
};
</script>

<style></style>
